export const USER_ACCESS_ROLE_FALLBACK = "-";
export const USER_ACCESS_ROLES_TITLE = "Access Groups";
